import { useEffect, useState } from "react";
import { GetDropdownListItems } from "../../services/DropdownListService";

// Loads the active values of an admin-managed dropdown list.
// `currentValue` is a value already saved on the record (or an array of them, for grids with
// one dropdown per row): if it has since been renamed or deleted it is appended, so existing
// records still show what was originally chosen.
const useDropdownList = (listType, currentValue = "") => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await GetDropdownListItems(listType);
        if (!cancelled) setOptions((response?.results || []).map((item) => item.value));
      } catch (error) {
        console.error(`Error loading dropdown list ${listType}:`, error);
        if (!cancelled) setOptions([]);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [listType]);

  const saved = (Array.isArray(currentValue) ? currentValue : [currentValue]).filter(Boolean);
  const missing = [...new Set(saved)].filter((value) => !options.includes(value));
  return missing.length ? [...options, ...missing] : options;
};

export default useDropdownList;
